import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';
import { DialogService } from '../../../core/services/dialog.service';
import { LoadingService } from '../../../core/services/loading.service';
import { ROUTE_MAP } from '../../../core/utils/module-route.map';
import { APP_ROUTES } from '../../../core/constants/app-route.constants';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loginForm: FormGroup;
  hidePassword = true;
  isLoading = false;
  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private dialogs: DialogService,
    private loading: LoadingService,
  ) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(4)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.loading.show('Iniciando sesión...');

    this.isLoading = true;
    // Accedes a los valores mediante this.loginForm.value
    this.auth.login(this.loginForm.value).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.loading.hide();

        if (res.kind === 'CHANGE_PASSWORD') {
          this.router.navigateByUrl(
            `/auth/change-temp-password?u=${encodeURIComponent(res.username)}`,
          );
          return;
        }

        // OK
        const startRoute = this.getStartRoute(res.accessGrouped);
        this.router.navigateByUrl(startRoute);
      },
      error: (err) => {
        this.loading.hide();
        this.isLoading = false;
        this.dialogs.error('Error', err?.error?.message ?? 'Error de login');
      },
    });
  }

  private getStartRoute(accessGrouped: any[]): string {
    if (!accessGrouped?.length) return APP_ROUTES.NO_ACCESS;

    for (const m of accessGrouped) {
      for (const a of m.actions || []) {
        const action = String(a.actionName).trim().toUpperCase();

        const route = ROUTE_MAP[m.moduleName]?.[action];
        if (route) return route;
      }
    }

    return APP_ROUTES.NO_ACCESS;
  }

  goForgotPassword() {
    this.router.navigateByUrl('/auth/forgot-password');
  }
}
